import {InvalidTokenError} from '@packages/utils';
import {parseCookies} from 'nookies';
import {useCallback, useState} from 'react';
import {
  deleteColumnMyClips,
  updateColumnMyClips,
} from '../../../core/repositories/clipsRepository';
import {useIsSessionExpired} from '../../../core/usecases/auth/useIsSessionExpired';

type HandleClipUpdateProps = {
  columnId: string;
  clipCount: number;
  isClipped: boolean;
};

export function useHandleColumnClip({
  columnId,
  clipCount,
  isClipped,
}: HandleClipUpdateProps) {
  const [clipCountUpdated, setClipCountUpdated] = useState<number>(clipCount);
  const [isClipUpdated, setIsClipUpdated] = useState<boolean>(isClipped);
  const {updateIsSessionExpired} = useIsSessionExpired();

  const deleteColumnUseCase = useCallback(
    async function deleteUseCase() {
      const cookies = parseCookies();
      const result = await deleteColumnMyClips({
        cookies,
        columnId,
      });
      if (!result.ok && result.error === InvalidTokenError) {
        updateIsSessionExpired(true);
      }

      if (!result.ok) {
        return;
      }

      setIsClipUpdated(false);
      setClipCountUpdated(clipCountUpdated - 1);
    },
    [columnId, clipCountUpdated],
  );

  const updateColumnUseCase = useCallback(
    async function updateUseCase() {
      const cookies = parseCookies();
      const result = await updateColumnMyClips({
        cookies,
        columnId,
      });

      if (!result.ok && result.error === InvalidTokenError) {
        updateIsSessionExpired(true);
      }

      if (!result.ok) {
        return;
      }

      setIsClipUpdated(true);
      setClipCountUpdated(clipCountUpdated + 1);
    },
    [columnId, clipCountUpdated],
  );

  const handleClip = useCallback(async () => {
    // 各ユースケースを呼び出す
    if (isClipUpdated) {
      await deleteColumnUseCase();
      return;
    }

    await updateColumnUseCase();
  }, [deleteColumnUseCase, isClipUpdated, updateColumnUseCase]);

  return {handleClip, clipCount: clipCountUpdated, isClipped: isClipUpdated};
}
